import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatModule } from 'core/material/mat.module';
import { PriceModule } from 'core/price/price.module';
import { TranslationModule } from 'core/translation/translation.module';
import { FinalizeDesignDirective } from './finalize-design.directive';
import { ProgressButtonsComponent
       } from './progress-buttons/progress-buttons.component';
import { ProgressNavigationComponent
       } from './progress-navigation/progress-navigation.component';
import { ValidateDesignStepDirective } from './validate-design-step.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatModule,
    PriceModule,
    TranslationModule,
  ],
  declarations: [
    FinalizeDesignDirective,
    ProgressButtonsComponent,
    ProgressNavigationComponent,
    ValidateDesignStepDirective,
  ],
  exports: [
    ProgressButtonsComponent,
    ProgressNavigationComponent,
  ],
  providers: [
    ValidateDesignStepDirective,
  ],
})
export class ProgressModule { }
